import { render, staticRenderFns } from "./UserAlbumPage.vue?vue&type=template&id=55ee16be&scoped=true&"
import script from "./UserAlbumPage.vue?vue&type=script&lang=js&"
export * from "./UserAlbumPage.vue?vue&type=script&lang=js&"
import style0 from "./UserAlbumPage.vue?vue&type=style&index=0&id=55ee16be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ee16be",
  null
  
)

export default component.exports